export enum CalculatorServiceRentNewEnum
{
     None = 0, // None
     ManagementBasic = 1, // Pakiet serwisowy Basic
     PetrolCard = 2, // Karta paliwowa
     Tires = 3, // Pakiet Opony
     Assistance = 5, // Assistance
     Insurance = 6, // Ubezpieczenie
     ManagementComfort = 7, // Pakiet serwisowy Comfort
     ManagementPrestigeNonAso = 8, // Pakiet serwisowy Prestige nonASO
     ManagementPrestige = 9, // Pakiet serwisowy Prestige
}

export enum CalculatorServiceLeasingNewEnum
{
     TechnicalService = 1, // Pakiet serwisowy Technical
     PetrolCard = 2, // Karta paliwowa
     TiresService = 3, // Pakiet Opony
     Assistance = 5, // Assistance
     Insurance = 6, // Ubezpieczenie
}

export enum CalculatorServiceRentAfterleaseEnum
{
    TechnicalService = 1, // Pakiet serwisowy Technical
    PetrolCard = 2, // Karta paliwowa
    TiresService = 3, // Pakiet Opony
    Assistance = 5, // Assistance
    Insurance = 6, // Ubezpieczenie
}

export enum CalculatorServiceLeasingAfterleaseEnum
{
    TechnicalService = 1, // Pakiet serwisowy Technical
    PetrolCard = 2, // Karta paliwowa
    TiresService = 3, // Pakiet Opony
    Assistance = 5, // Assistance
    Insurance = 6, // Ubezpieczenie
}